import { ServiceTokens } from "$src/domain/ServiceTokens";
import type { IProjectRepository } from "$src/domain/projects/IProjectRepository";
import { Project } from "$src/domain/projects/Project";
import { inject, injectable } from "tsyringe";
import { projectOriginal } from "../stores/projectStore";

@injectable()
export class GetProjectById {
    
    constructor(@inject(ServiceTokens.ProjectService) private projectRepository: IProjectRepository) {}

    async execute(groupStoreId: number, projectId: number): Promise<Project> {
        var project = await this.projectRepository.getProjectById(groupStoreId, projectId);

        projectOriginal.set(project);

        return project;
    }
}

export const GetProjectByIdToken = Symbol('GetProjectByIdToken');    
